import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Plus, Trash2, Landmark } from "lucide-react";

export default function MetodosPago() {
  const [bancos, setBancos] = useState([]);
  const [nombre, setNombre] = useState("");
  const [tipo, setTipo] = useState("banco");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get("/bancos");
    setBancos(data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!nombre.trim()) return toast.error("Escribe un nombre");
    setBusy(true);
    try {
      await api.post("/bancos", { nombre: nombre.trim(), tipo, activo: true });
      toast.success("Método de pago creado");
      setNombre("");
      load();
    } catch { toast.error("No se pudo crear"); }
    finally { setBusy(false); }
  };

  const remove = async (b) => {
    if (!window.confirm(`¿Eliminar "${b.nombre}"?`)) return;
    try {
      await api.delete(`/bancos/${b.id}`);
      toast.success("Eliminado");
      load();
    } catch { toast.error("No se pudo eliminar"); }
  };

  return (
    <div className="space-y-6" data-testid="metodos-pago-page">
      <header>
        <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500 font-semibold">Configuración</div>
        <h1 className="font-manrope font-black tracking-tight text-4xl mt-1 flex items-center gap-3">
          <Landmark className="w-8 h-8" /> Métodos de Pago
        </h1>
        <p className="text-zinc-500 mt-2 text-sm">Bancos, efectivo y otras cuentas disponibles al facturar.</p>
      </header>

      <Card className="p-6 border-zinc-200 rounded-md">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold mb-3">Nuevo método</div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
          <div className="md:col-span-6">
            <Label className="text-xs uppercase tracking-widest">Nombre</Label>
            <Input value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej. BAM, BI, Banrural, Efectivo…" data-testid="mp-nombre" />
          </div>
          <div className="md:col-span-3">
            <Label className="text-xs uppercase tracking-widest">Tipo</Label>
            <select value={tipo} onChange={(e) => setTipo(e.target.value)} className="h-10 border border-zinc-200 rounded-md px-3 text-sm w-full" data-testid="mp-tipo">
              <option value="banco">Banco</option>
              <option value="efectivo">Efectivo</option>
            </select>
          </div>
          <div className="md:col-span-3">
            <Button onClick={add} disabled={busy} className="w-full bg-[#002FA7] hover:bg-[#00227A] gap-2" data-testid="mp-add">
              <Plus className="w-4 h-4" /> Agregar
            </Button>
          </div>
        </div>
      </Card>

      <Card className="border-zinc-200 rounded-md overflow-hidden">
        <div className="p-5 border-b border-zinc-200">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">Registrados</div>
          <div className="text-xl font-semibold mt-0.5">{bancos.length} método{bancos.length === 1 ? "" : "s"}</div>
        </div>
        <div className="divide-y divide-zinc-100">
          {bancos.length === 0 && <div className="text-center text-zinc-400 py-10 text-sm">Sin métodos aún.</div>}
          {bancos.map((b) => (
            <div key={b.id} className="flex items-center justify-between px-5 py-3">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-md grid place-items-center ${b.tipo === "efectivo" ? "bg-emerald-100 text-emerald-700" : "bg-indigo-100 text-indigo-700"}`}>
                  <Landmark className="w-4 h-4" />
                </div>
                <div>
                  <div className="font-semibold">{b.nombre}</div>
                  <div className="text-[10px] uppercase tracking-widest text-zinc-500">{b.tipo}</div>
                </div>
              </div>
              <button onClick={() => remove(b)} className="text-red-600 hover:bg-red-50 rounded p-2" data-testid={`mp-del-${b.nombre}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
